import React from "react"

import Websites from "./components/linkie/Websites";

export default class FixedWebsites extends React.Component {

  constructor(props) {
    super(props)

    window.General.StatStatus = false

    this.state = {

    }
  }

  componentDidMount() {

  }


  render() {
    let {

    } = this.state

    return (
      <>
        <Websites
          type="system_default"
        />
      </>
    )

  }

}
